import { render, staticRenderFns } from "./LabeledStatusBadge.vue?vue&type=template&id=4f7811d4&scoped=true"
import script from "./LabeledStatusBadge.vue?vue&type=script&lang=js"
export * from "./LabeledStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./LabeledStatusBadge.vue?vue&type=style&index=0&id=4f7811d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7811d4",
  null
  
)

export default component.exports